export const activityType = {
  CONFIGURATION_IMPORT: 'configurationsImport',
  GENERATE_REPORT: 'generateReport',
  INTEGRATION_RESPONSE: 'integrationResponse',
  INSIGHTS: 'insights',
  DNS_TWIST: 'dnsTwist',
};
export const configurationsImportSource = {
  CSV: 'csv',
};
export const ActivityFinishedStatus = {
  SUCCESS: 'success',
  FAILED: 'failed',
};
